import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRuler24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRuler24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 11V4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1.5H9.75a.75.75 0 0 0 0 1.5h1.75v1.5H9.75a.75.75 0 0 0 0 1.5h1.75v1zM5 11V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v7h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm1.5 9v-1h5v1a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5M20 17.5H4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1.5v1.75a.75.75 0 0 0 1.5 0V12.5h1.5v1.75a.75.75 0 0 0 1.5 0V12.5h1.5v1.75a.75.75 0 0 0 1.5 0V12.5h1.5v1.75a.75.75 0 0 0 1.5 0V12.5h1.5v1.75a.75.75 0 0 0 1.5 0V12.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRuler24);
